module.exports = __webpack_public_path__ + "assets/img/12.e2489a5b.png";